export async function fetchAllPaginatedItems(fetchPage, pageSize = 250) {
  const items = [];
  let page = 1;
  let total = null;

  while (true) {
    const response = await fetchPage(page, pageSize);
    const pageItems = Array.isArray(response?.items) ? response.items : [];

    items.push(...pageItems);

    if (typeof response?.total === 'number') {
      total = response.total;
    }

    if (pageItems.length === 0) break;
    if (total !== null && items.length >= total) break;

    page += 1;
  }

  return items;
}
